import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CompensationSchema, IDocumentState, IOfferLetter } from './type';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IDocumentState = {
  addCompensation: {},
  addOfferLetter: {},
};

const slice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    addCompensation(state, action: PayloadAction<CompensationSchema>) {
      state.addCompensation.status = RequestStatus.RUNNING;
    },
    addCompensationSuccess(state, action) {
      state.addCompensation.status = RequestStatus.SUCCESS;
      state.addCompensation.data = action.payload;
    },
    addCompensationFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addCompensation.status = RequestStatus.ERROR;
      state.addCompensation.error = action.payload;
    },
    //
    addOfferLetter(state, action: PayloadAction<IOfferLetter>) {
      state.addOfferLetter.status = RequestStatus.RUNNING;
    },
    addOfferLetterSuccess(state, action) {
      state.addOfferLetter.status = RequestStatus.SUCCESS;
      state.addOfferLetter.data = action.payload;
    },
    addOfferLetterFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addOfferLetter.status = RequestStatus.ERROR;
      state.addOfferLetter.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  addCompensation,
  addCompensationSuccess,
  addCompensationFailed,
  addOfferLetter,
  addOfferLetterSuccess,
  addOfferLetterFailed,
} = slice.actions;
